import React, { useCallback, useState } from 'react';
import { Box, Divider } from '@mui/material';
import { Baseline } from '@shared/models/project.model';
import { getElementProperties } from '@shared/helpers/element-property.helpers';
import { PANEL_CONTENT_DEFAULT_SPACING } from '@ui/layout/panels/panel.constants';
import { SidePanelAccordionSection } from '../../SidePanelAccordionSection';
import { ElementPropertiesForm } from '../../ElementSidePanelContent/components/ElementCoreSettings/ElementPropertiesForm';
import { ElementPropertyMenu } from '@ui/menus/ElementPropertyMenu';
import { ContentCoverageSection } from '../../ElementSidePanelContent/components/ContentCoverageSection';

const accordionContentPadding = PANEL_CONTENT_DEFAULT_SPACING;

type BuildingVersionPropertiesAccordionProps = {
  version: Baseline;
};

export const BuildingVersionPropertiesAccordion: React.FC<
  BuildingVersionPropertiesAccordionProps
> = ({ version }) => {
  const properties = getElementProperties(version);
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  const openMenu = useCallback(
    (event: React.MouseEvent<HTMLElement>) => setAnchor(event.currentTarget),
    [],
  );
  const closeMenu = useCallback(() => setAnchor(null), []);

  return (
    <SidePanelAccordionSection
      summary="Properties"
      onIconClick={openMenu}
      disablePadding
    >
      <Box
        sx={{
          px: accordionContentPadding,
          pt: 1,
          pb: 1,
        }}
      >
        <ElementPropertiesForm
          emptyStateCopy="No properties configured"
          emptyStateCentered
          element={version}
          properties={properties}
        />
      </Box>
      <Divider />
      <Box
        sx={{
          px: accordionContentPadding,
          pt: 1,
          pb: 1,
        }}
      >
        <ContentCoverageSection element={version} embedded />
      </Box>
      <ElementPropertyMenu
        anchor={anchor}
        element={version}
        onClose={closeMenu}
      />
    </SidePanelAccordionSection>
  );
};
